import { createSlice, type PayloadAction } from '@reduxjs/toolkit';

import type { CustomPopup, PopupStackItem } from './types';

const initialState: {
  popupStack: PopupStackItem[];
  currentPopup: PopupStackItem | null;
  customPopup: CustomPopup | null;
} = {
  popupStack: [],
  currentPopup: null,
  customPopup: null,
};

export const popupSlice = createSlice({
  name: 'popup',
  initialState,
  reducers: {
    pushPopup: (state, action: PayloadAction<string>) => {
      const popupStackItem: PopupStackItem = {
        popupName: action.payload,
      };

      state.popupStack.push(popupStackItem);
      if (!state.currentPopup) {
        state.currentPopup = popupStackItem;
      }
    },
    pushPopupWithData: (state, action: PayloadAction<PopupStackItem>) => {
      const popupStackItem: PopupStackItem = {
        popupName: action.payload.popupName,
        popupData: action.payload.popupData,
      };

      state.popupStack.push(popupStackItem);
      if (!state.currentPopup) {
        state.currentPopup = popupStackItem;
      }
    },
    popPopup: (state) => {
      state.popupStack.pop();
    },
    setCustomPopup: (state, action: PayloadAction<CustomPopup>) => {
      state.customPopup = action.payload;
    },
    overwritePopup: (state, action: PayloadAction<string>) => {
      const popupStackItem: PopupStackItem = {
        popupName: action.payload,
      };
      state.popupStack.unshift(popupStackItem);
      state.currentPopup = popupStackItem;
    },
    overwritePopupWithData: (state, action: PayloadAction<PopupStackItem>) => {
      const popupStackItem: PopupStackItem = {
        popupName: action.payload.popupName,
        popupData: action.payload.popupData,
      };
      state.popupStack.unshift(popupStackItem);
      state.currentPopup = popupStackItem;
    },
    dismissPopup: (state, action: PayloadAction<string>) => {
      state.popupStack = state.popupStack.filter((popup) => popup.popupName !== action.payload);
      if (state.currentPopup?.popupName === action.payload) {
        state.currentPopup = state.popupStack[0] || null;
      }
    },
    dismissCurrentPopup: (state) => {
      state.popupStack = state.popupStack.filter((popup) => popup.popupName !== state.currentPopup?.popupName);
      state.currentPopup = state.popupStack[0] || null;
    },
  },
});

export const popupActions = popupSlice.actions;
